export const mapTypeToFieldType = (type) => {
  switch(type) {
    case "SELECT":
      return "select"
    case "STRING":
    default:
      return "text";
  }
}
